export default __webpack_public_path__ + "static/media/send.d338beb6.svg";